import { render, staticRenderFns } from "./BgColumnFilesCount.vue?vue&type=template&id=b0dc8eca"
import script from "./BgColumnFilesCount.vue?vue&type=script&lang=js"
export * from "./BgColumnFilesCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports